import { AxiosInstance } from 'axios';
import { Result } from 'services/Result';

export type RecurlyItemStatus = {
  exists: boolean;
  itemUrl: string;
};

export class EditCertificationService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getAvailablePrerequisites = async (id: string) => {
    const response = await this.axiosInstance.get<Result<{ id: string; title: string }[]>>(
      `/api/admin/learning-hub/certification-tests/${id}/available-prerequisites`
    );
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching prerequisites.');
  };

  getRecurlyItemStatus = async (certificationId: string): Promise<RecurlyItemStatus> => {
    const response = await this.axiosInstance.get<Result<RecurlyItemStatus>>(
      `/api/admin/learning-hub/certification-tests/${certificationId}/recurly-item-status`
    );
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching Recurly item status.');
  };

  syncWithCatalog = async (certificationId: string): Promise<void> => {
    await this.axiosInstance.post(
      `/api/admin/learning-hub/certification-tests/${certificationId}/sync-catalog`
    );
  };
}
